module.exports = __webpack_public_path__ + "media/images/logos/stem-logo-small-89400e4993949e122993241b470e08b2.svg";